import { DefaultRequest } from 'scripts/api';

Greenmile.Task = Greenmile.Task || {};

Greenmile.Task.Suggested = function () {

    this.pathActions = { accept: 'Accept', decline: 'Decline' };

    this.buildSection = (resource, mainClass = '') => {
        const taskForm = document.querySelector('#Task .MonetUIForm');
        const sectionBuilder = new Monet.Builder.Form.Horizontal();
        const sectionContainer = sectionBuilder.createContainer(`MonetUIFormSection ${mainClass}`);
        const sectionToRender = sectionBuilder.renderAndAppendTitle(sectionContainer, { description: this.getResourceTo(resource) });
        const commentContainer = document.querySelector('#Task #taskCommentContainer');
        taskForm.insertBefore(sectionToRender, commentContainer);

        return sectionContainer;
    };

    this.buildContainerToContent = (classToContent) => {
        const container = document.createElement('div');
        container.setAttribute('class', classToContent);

        return container;
    };

    this.getSection = (mainClass) => {
        return document.querySelector(`#Task .MonetUIForm .MonetUIFormSection.${mainClass}`);
    };

    const renderButton = (label, actionCallback) => {
        const btn = new Monet.UI.Fields.Button();
        btn.setValue(this.getResourceTo(label));
        btn.setClassName('MonetUIButton btn');
        if(actionCallback) {
          btn.addEventClickListener(actionCallback);
        }
        return btn;
    };

    this.buildButtons = (containerMapAndButtons, taskId) => {
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'sectionButtons standard-form-buttons';
        const requestToAccept = requestTo(this.pathActions.accept, taskId);
        const requestToDecline = requestTo(this.pathActions.decline, taskId);

        this.acceptButton = renderButton('Task.AcceptSuggestion.label.button', this.showAlertPopupForm(requestToAccept, this.pathActions.accept));
        this.declineButton = renderButton('Task.DeclineSuggestion.label.button', this.showAlertPopupForm(requestToDecline, this.pathActions.decline));

        buttonsContainer.appendChild(this.acceptButton.render());
        buttonsContainer.appendChild(this.declineButton.render());
        containerMapAndButtons.appendChild(buttonsContainer);
    };

    const requestTo = (pathToAction, taskId) => {
        return () => {
            try {
                handleLoading(pathToAction);
                const request = new DefaultRequest({
                  url: `Task/${pathToAction}`,
                  method: "post",
                  data: { id: taskId },
                  success: (data) => {
                    console.log('success to ' + pathToAction);
                    App.Objects.Task.edit(null, taskId);
                  },
                  error: (xhr) => {
                    Monet.Configurations.errorNotification(null, xhr);
                    handleLoading(pathToAction);
                  }
                });
                request.send();
            } catch (e) {
                const error = new Monet.Exception.ReturnError(
                  this,
                  `Error occured trying to ${pathToAction} suggestion.`,
                  e
                );
                error.console();
            }
        };
    };

    const handleLoading = (pathToAction) => {
        if(pathToAction === this.pathActions.accept) {
            this.acceptButton.toggleLoadingInBtn();
            this.declineButton.toggleDisabled();
        } else if(pathToAction === this.pathActions.decline) {
            this.declineButton.toggleLoadingInBtn();
            this.acceptButton.toggleDisabled();
        }
    };

    this.disableButtonsTo = (mainClass) => {
        return () => {
            const buttonsContainer = document.querySelector(`#Task .${mainClass} .sectionButtons`);
            const buttons = [...buttonsContainer.childNodes];
            buttons.forEach( button => button.setAttribute('disabled', 'disabled') );
        };
    };

    this.getResourceTo = (resourceKey) => Monet.I18n.getResourcesByKey(resourceKey);

    this.checkSuggestionAlreadyDone = (taskFormStatus) => {
        if(taskFormStatus) {
            switch (taskFormStatus) {
              case 'ACCEPTED':
                this.handleAlreadyDone('Accept')();
                break;
              case 'DECLINED':
                this.handleAlreadyDone('Decline')();
                break;
            }
          }
    };

    this.showAlertPopupForm = (requestTo, pathAction) => {
        return () => {
          const selector = "#Task .span10.form_and_grid_generic";
          const options = {
            width: 600,
            height: 180
          }
          this.formModal = new Monet.Form.Modal(selector, options);
          this.formModal.showModalForm();

          const modalContent = this.buildContainerToContent('content');
          const divTexts = this.buildContainerToContent('');
      
          const popupTitle = document.createElement("h1");
          popupTitle.className = "popupTitle";
          popupTitle.innerHTML = this.getResourceTo('Task.confirmAlertModalSuggested.title');
      
          const popupMessage = document.createElement("p");
          const actionTypeFromResource = this.getResourceTo(`Task.confirmAlertModalSuggested.${pathAction}`);
          const phraseToShow = Monet.I18n.translateResources('Task.confirmAlertModalSuggested.askMessage', {
              actionType: actionTypeFromResource,
          });

          popupMessage.innerHTML = `${phraseToShow}?`;
      
          divTexts.appendChild(popupTitle);
          divTexts.appendChild(popupMessage);
      
          const divButtons = this.buildContainerToContent('buttons standard-form-buttons');

          const confirmBtn = renderButton(this.getResourceTo('default.button.confirm'), () => {
              requestTo();
              this.formModal.closeModalWindow();
            }).render();
          const cancelBtn = renderButton(this.getResourceTo('default.button.cancel'), () => { this.formModal.closeModalWindow() }).render();

          divButtons.appendChild(confirmBtn);
          divButtons.appendChild(cancelBtn);

          modalContent.appendChild(divTexts);
          modalContent.appendChild(divButtons);
      
          const modal = document.querySelector(selector).querySelector(".popupFormContainer");
          modal.appendChild(modalContent);
        };

    };

    this.showWhoAndWhen = (modelAttributes, mainClass, typeAction) => {
        const { userChangeTaskFormStatus, whenTaskFormStatusChanged } = modelAttributes;
        const container = this.buildContainerToContent('whoAndWhenDoneSuggestion');
        const whenDate = Monet.Format.DateTime.formatToLocale(whenTaskFormStatusChanged);
        const actionResource = this.getResourceTo(`Task.whoAndWhenWasProcessedSuggestion.${typeAction}`);
        const phraseToShow = Monet.I18n.translateResources('Task.whoAndWhenSuggestionProcessed', {
            actionType: actionResource.toLowerCase(),
            whoProcessedSuggestion: userChangeTaskFormStatus.login,
            whenProcessedSuggestion: whenDate
        });

        container.innerHTML = phraseToShow;

        const sectionLastChild = this.getSection(mainClass).lastChild;

        sectionLastChild.insertBefore(container, sectionLastChild.lastChild);
    };

    return this;
};